import {BaseConfig} from "../../../../infrastructure/config/base-config";
import {MegaHeaderModuleTerms} from "./mega-header-module.terms";
import {SPORT_TYPES} from "../../../../core/app/consts";


export class MegaHeaderModuleConfig extends BaseConfig {
  activeSportId: Number;

  static injectables = [MegaHeaderModuleTerms];

  constructor(terms: MegaHeaderModuleTerms) {
    super('megaHeaderModule', null, terms);

    this.activeSportId = SPORT_TYPES.football;
  }
}
